<div class="d-inline-flex">
  <ncp-button
    #addVaccinationButton
    [options]="btnVacOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.devices.syringe.src"
      width="18"
      height="18"
      alt="Add Vaccination"
      class="healthIcon"
    />
  </ncp-button>
  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="vaccinations_form"
      name="vaccinations_form"
      [formGroup]="form"
      #vFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown
        #vaccinationDesc
        [(options)]="vaccinationDescDDOptions"
      />
      <div class="row g-3">
        <div class="col-md-6">
          <label for="description" class="form-label">
            {{translations.description}}
          </label>
          <div
            id="description"
            class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0"
          >
            @if (vaccinationDescDDOptions().value) {
              <div class="text-uppercase">
                {{vaccinationDescDDOptions().value!.display_name}}
              </div>
            } @else {
              -
            }
          </div>
        </div>
        <div class="col-md-6">
          <label for="brandName" class="form-label">
            {{translations.brand_name}}
          </label>
          <div
            id="brandName"
            class="d-flex flex-column form-text border border-1 rounded-2 border-secondary bg-secondary-subtle viewText m-0"
          >
            @if (vaccinationDescDDOptions().value) {
              <div class="text-uppercase">
                {{vaccinationDescDDOptions().value!.product_name}}
              </div>
            } @else {
              -
            }
          </div>
        </div>
      </div>
      <ncp-date
        #vaccineDate
        [(options)]="vaccinationDateOptions"
      />
      <div class="row g-3">
        <div class="col-md-6">
          <label for="vaccinationReason" class="form-label">
            Vaccination Reason
          </label>
          <input
            id="vaccinationReason"
            type="text"
            class="form-control"
            formControlName="vaccination_reason"
            maxlength="256"
          />
        </div>
        <div class="col-md-6">
          <label for="vaccinationStatus" class="form-label">
            Vaccination Status
          </label>
          <input
            id="vaccinationStatus"
            type="text"
            class="form-control"
            formControlName="vaccination_status"
            maxlength="32"
          />
        </div>
        <div class="col-md-6">
          <label for="seriesNumber" class="form-label">
            Series Number
          </label>
          <input
            id="seriesNumber"
            type="number"
            class="form-control"
            formControlName="series_number"
            min="0"
          />
        </div>
        <div class="col-md-6">
          <label for="batchNumber" class="form-label">
            Batch Number
          </label>
          <input
            id="batchNumber"
            type="text"
            class="form-control"
            formControlName="batch_number"
            maxlength="64"
          />
        </div>
      </div>
      <ncp-date
        #nextVaccineDate
        [(options)]="vaccinationNextDateOptions"
      />
      <div class="row g-3">
        <div class="col-md-6">
          <label for="presenceAdverseEvent" class="form-label">
            Presence Adverse Event
          </label>
          <input
            id="presenceAdverseEvent"
            type="text"
            class="form-control"
            formControlName="presence_adverse_event"
            maxlength="64"
          />
        </div>
        <div class="col-md-6">
          <label for="reportedAdverseEvent" class="form-label">
            Reported Adverse Event
          </label>
          <input
            id="reportedAdverseEvent"
            type="text"
            class="form-control"
            formControlName="reported_adverse_event"
            maxlength="64"
          />
        </div>
        <div class="col-md-6">
          <label for="adverseEventCode" class="form-label">
            Adverse Event Code
          </label>
          <input
            id="adverseEventCode"
            type="text"
            class="form-control"
            formControlName="adverse_event_code"
            maxlength="64"
          />
        </div>
      </div>

      <hr class="my-2">

      <div>
        <label class="form-label">
          Diseases
        </label>
        <div class="d-flex align-items-end gap-2">
          <div class="flex-grow-1">
            <ncp-dropdown
              #diseaseDropdown
              [(options)]="diseaseDDOptions"
            />
          </div>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!diseaseDDOptions().value"
            (click)="addDisease()"
          >
            <i class="bi bi-plus-lg"></i>
            Add
          </button>
        </div>
      </div>

      @if (selectedDiseases().length > 0) {
        <div class="border rounded p-2">
          @for (disease of selectedDiseases(); track disease.disease_coding_id) {
            <div class="d-flex align-items-center justify-content-between border-bottom py-2">
              <div>
                <div class="fw-semibold">
                  {{disease.description}}
                </div>
                @if (disease.code) {
                  <small class="text-muted">
                    {{disease.code}}
                  </small>
                }
              </div>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger"
                (click)="removeDisease(disease.disease_coding_id!)"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          }
        </div>
      }

      <div>
        <label for="observations" class="form-label">
          Observations
        </label>
        <textarea
          id="observations"
          class="form-control"
          formControlName="observations"
          maxlength="256"
          rows="3"
        ></textarea>
      </div>
      <div>
        <label for="note" class="form-label">
          Note
        </label>
        <textarea
          id="note"
          class="form-control"
          formControlName="note"
          maxlength="256"
          rows="3"
        ></textarea>
      </div>

      <ng-template #vaccinesTemplate let-value>
        <div class="d-flex flex-row">
          <div class="col-6 text-wrap">{{value.product_name}}</div>
          <div class="col-6 text-wrap">{{value.display_name}}</div>
        </div>
      </ng-template>

      <ng-template #diseasesTemplate let-value>
        <div class="d-flex flex-column">
          <div class="text-wrap">{{value.description}}</div>
          @if (value.code) {
            <small class="text-muted">{{value.code}}</small>
          }
        </div>
      </ng-template>
    </form>
  </ncp-modal>
</div>
